import React, { useState } from 'react';
import { Checkbox, Row, Col, Input } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const CheckValue = ({
    title,
    items,
    value,
    changeValue,
    isAll,
    isFind,
    confirm,
    keyEl,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [findString, setFindString] = useState('');

    const changeHandler = (e, key) => {
        if (changeValue) {
            if (!e.target.checked) {
                changeValue(value.filter((item) => item !== key));
            } else {
                changeValue([...value, key]);
            }
        }
    };

    const clearHandler = () => {
        if (changeValue) {
            changeValue([]);
            if (confirm) {
                confirm(keyEl);
            }
        }
    };

    const checkAll = (e) => {
        if (e.target.checked) {
            const res = [];
            (isFind && !!findString
                ? items.filter((item) => item.key.indexOf(findString) === 0)
                : items
            )?.forEach((item) => {
                if (item.count) {
                    res.push(item.value);
                }
            });
            changeValue(res);
        } else {
            changeValue([]);
        }
    };
    return (
        <Row className="filter-check-container">
            <Row className="container-filter-title">
                <Col
                    className="check-title"
                    style={{
                        maxWidth: '88%',
                    }}
                >
                    {title}
                </Col>
                {isOpen ? (
                    <UpOutlined onClick={() => setIsOpen(false)} />
                ) : (
                    <DownOutlined onClick={() => setIsOpen(true)} />
                )}
            </Row>
            <Row justify="end" style={{ height: '8px' }}>
                {value?.length > 0 && (
                    <Col
                        style={{ fontSize: '10px', cursor: 'pointer' }}
                        onClick={() => clearHandler()}
                    >
                        Сбросить
                    </Col>
                )}
            </Row>

            <Row
                className={`filter-check-container-main ${
                    isOpen ? 'open' : ''
                }`}
                style={{
                    '--i': `${
                        (items.length + (isAll ? 1 : 0) + (isFind ? 1 : 0)) * 30
                    }px`,
                }}
            >
                {isFind && (
                    <Col>
                        <Input
                            className="filter-find-check"
                            value={findString}
                            onChange={(e) => setFindString(e.target.value)}
                            placeholder="Поиск"
                        />
                    </Col>
                )}
                {isAll &&
                    (isFind && !!findString
                        ? items.filter(
                              (item) => item.title.indexOf(findString) === 0
                          )
                        : items
                    )?.length > 0 && (
                        <Col className="check-all-container">
                            <Checkbox onChange={(e) => checkAll(e)}>
                                Выбрать все
                            </Checkbox>
                        </Col>
                    )}
                {(isFind && !!findString
                    ? items.filter(
                          (item) => item.title.indexOf(findString) === 0
                      )
                    : items
                )?.map((item) => (
                    <Col key={item.key}>
                        <Checkbox
                            checked={
                                (value ?? []).findIndex(
                                    (el) => el === item.key
                                ) !== -1
                            }
                            onChange={(e) => changeHandler(e, item.key)}
                            disabled={!item.doc_count}
                        >
                            {item.name ?? item.key}
                            {!!item.doc_count && (
                                <span className="title-count">{` (${item.doc_count})`}</span>
                            )}
                        </Checkbox>
                    </Col>
                ))}
            </Row>
        </Row>
    );
};

export default CheckValue;
